module.exports = __webpack_public_path__ + "img/1-squoll-facebook-pixel-google-ads-mob-md.8452d209.png";